import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '@features/auth/model/slice';
import themeReducer from '@features/theme/model/slice';
import analysisProgressReducer from '@features/analysisProgress/model/slice';
import announcementsReducer from '@features/announcements/model/slice';
import { osnovaApi } from '@shared/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    analysisProgress: analysisProgressReducer,
    announcements: announcementsReducer,
    [osnovaApi.reducerPath]: osnovaApi.reducer,
  },
  middleware: (getDefault) => getDefault().concat(osnovaApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
